import React, { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TablesOrder from "./TablesOrder";
import DeliveryOrders from "./DeliveryOrders";
import TakeAwayOrders from "./TakeAwayOrders";
import {
	getDeliveryOrders,
	getTablesWithOrders,
	getTakeawayOrders,
} from "../../../../../services/Admin/SalesScreenApi";


const TAB_KEY = "orders_tab";

const OrdersScreen = () => {
	const [underReviewCount, setUnderReviewCount] = useState(0);
	const [deliveryUnderReviewCount, setDeliveryUnderReviewCount] = useState(0);
	const [takeawayUnderReviewCount, setTakeawayUnderReviewCount] = useState(0);
	const [tab, setTab] = useState(() => {
		const raw = localStorage.getItem(TAB_KEY);
		const parsed = Number(raw);
		return Number.isFinite(parsed) ? parsed : 0;
	});

	const loadUnderReviewCounts = useCallback(async () => {
		try {
			const [tablesRes, deliveryRes, takeawayRes] = await Promise.all([
				getTablesWithOrders(),
				getDeliveryOrders(),
				getTakeawayOrders(),
			]);

			const tables = Array.isArray(tablesRes?.data) ? tablesRes.data : [];
			const tableCount = tables.filter(
				(table) => table?.active_order?.status === "under_review"
			).length;
			setUnderReviewCount(tableCount);

			const deliveryOrders = Array.isArray(deliveryRes?.data) ? deliveryRes.data : [];
			const deliveryCount = deliveryOrders.filter(
				(order) => order?.status === "under_review"
			).length;
			setDeliveryUnderReviewCount(deliveryCount);

			const takeawayOrders = Array.isArray(takeawayRes?.data) ? takeawayRes.data : [];
			const takeawayCount = takeawayOrders.filter(
				(order) => order?.status === "under_review"
			).length;
			setTakeawayUnderReviewCount(takeawayCount);
		} catch (e) {
			setUnderReviewCount(0);
			setDeliveryUnderReviewCount(0);
			setTakeawayUnderReviewCount(0);
		}
	}, []);

	useEffect(() => {
		loadUnderReviewCounts();
		const intervalId = setInterval(() => {
			loadUnderReviewCounts();
		}, 10000);

		return () => clearInterval(intervalId);
	}, [loadUnderReviewCounts]);

	const handleChange = (_, v) => {
		setTab(v);
		loadUnderReviewCounts();
		try {
			localStorage.setItem(TAB_KEY, String(v));
		} catch (e) {}
	};

	return (
		<Box>
			<Tabs value={tab} onChange={handleChange} centered sx={{ mb: 2 }}>
				<Tab label={`الطاولات (${underReviewCount})`} />
				<Tab label={`الديلفري (${deliveryUnderReviewCount})`} />
				<Tab label={`التيكواي (${takeawayUnderReviewCount})`} />
			</Tabs>

			<Box>
				{tab === 0 && <TablesOrder />}
				{tab === 1 && <DeliveryOrders />}
				{tab === 2 && <TakeAwayOrders />}
			</Box>
		</Box>
	);
};

export default OrdersScreen;
